import { Controller } from "stimulus";

export default class extends Controller {
  static targets = ["input", "submitBtn", "counter", "messageTemplate", "tempIDField",  "replyPreview", "replyPreviewContent", "replyToMessageIdField"];

  connect() {
    
  }

  clearInput() {
    setTimeout(() => {
      this.inputTarget.value = ""
    }, 200);
  }

  submit(e) {
    e.preventDefault()
    if (this.inputTarget.value.length == 0) return;

    var messageTempID = this.generateMessageTempID();
    
    if (e.type == "retry-message-send") {
      messageTempID = e.detail.tempId;
    }
    this.tempIDFieldTarget.value = messageTempID;
    var inputValue = this.inputTarget.value;

    this.submitBtnTarget.click();
    this.inputTarget.value = "";
    this.counterTarget.innerText = 0;
    this.counterTarget.classList.add("hidden");

    
    var messages = document.getElementById("messagesList");
    var message = document.createElement("div");
    message.classList.add("temp-message-container");
    message.append(this.messageTemplateTarget.content.cloneNode(true));
    message.querySelector(".message-content").innerText = inputValue;
    
    
    
    message.id = messageTempID
    // message.querySelector(".temp-message").dataset.tempId = messageTempID;

    var messageHasAttachments = document.getElementById("message-attachments-input").files.length > 0;

    if (messageHasAttachments) {
      message.querySelector(".loading-attachments").classList.remove("hidden");
      document.getElementById("message-attachments-input").value = "";
    }

    messages.append(message);
    messages.scrollTop = messages.scrollHeight

    this.replyPreviewTarget.classList.add("hidden")
    this.replyToMessageIdFieldTarget.value = null

    setTimeout(() => {
      message.querySelector(".message-status-waiting").classList.remove("hidden");

      setTimeout(() => {
        message.querySelector(".message-status-waiting").classList.add("hidden");
        message.querySelector(".message-status-failed").classList.remove("hidden");
        message.querySelector(".message-bubble").style.background = "#ef8484";
        
        message.querySelector(".loading-attachments").classList.add("hidden");
      }, messageHasAttachments ? 10000 : 4000);

    }, 500);

  }



  generateMessageTempID() {
    return [...Array(11)].map(() => Math.floor(Math.random() * 16).toString(16)).join('');
  }


  replyTo(e) {
    var messageIDToReplyTo = e.detail.messageId;
    var messageContentToReplyTo = e.detail.messageContent;

    this.replyToMessageIdFieldTarget.value = messageIDToReplyTo;
    
    this.replyPreviewContentTarget.innerHTML = messageContentToReplyTo;
    this.replyPreviewTarget.classList.remove("hidden");

    this.inputTarget.focus();

  }

  closeReplyTo(e) {
    this.replyToMessageIdFieldTarget.value = null;
    this.replyPreviewContentTarget.innerText = "";
    this.replyPreviewTarget.classList.add("hidden");
  }

  


}